<template>
  <!-- prettier-ignore -->
  <div class="comparison-content">
    <div
      class="comparison-content__name"
      v-text="isComparison ? $props.content.comparisonTitle : $props.content.name"
    />

    <div
      v-if="$props.content.linkToContentPage"
      class="comparison-content__link"
    >
      <a
        class="comparison-content__product-link"
        target="_blank"
        :href="$props.content.linkToContentPage"
        v-text="$t('comparison.productPage')"
      />
    </div>

    <div
      class="comparison-content__description"
      v-html="$props.content.description"
    />

    <benefits-table
      v-if="showTable"
      :benefits-data="benefitsTableData"
    />
    <loading-alt v-else />

    <div
      class="comparison-content__disclaimer"
      v-html="$t('comparison.disclaimer')"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'

import useBenefits from '@/hooks/useBenefits'
import useResources from '@/hooks/useResources'

import BenefitsTable from '@/components/Benefits/BenefitsTable'
import LoadingAlt from '@/components/Container/LoadingAlt'

// HOOKS
const { getBenefitsTableData } = useBenefits()
const { fetchContentByPath } = useResources()

// INIT
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  product: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
})

// DATA
const benefitsTableData = ref(null)
const structure = ref(null)

// COMPUTED
const isComparison = computed(() => {
  return props.type === 'comparison'
})

const pack = computed(() => {
  return {
    path: props.content[`${props.type}Path`],
    columns: props.content[`${props.type}Columns`] || [],
  }
})

const showTable = computed(() => {
  return structure.value && benefitsTableData.value
})

// LIFECYCLE HOOKS
onMounted(() => {
  // load the correct file and pass that to the table-component
  if (pack.value?.path) {
    fetchContentByPath(pack.value.path).then(response => {
      structure.value = response

      benefitsTableData.value = getBenefitsTableData(response, pack.value.columns, props.product.productId)
    })
  }
})
</script>

<style name="mobile" scoped>
.comparison-content {
  display: flex;
  flex-direction: column;
  justify-content: center;

  &__name {
    font-size: 30px;
    line-height: 32px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  &__link {
    position: relative;
    margin-bottom: 20px;

    a:hover {
      border-bottom: none;
    }
  }

  &__description {
    border-top: 1px solid var(--c-secondary-neutral-3);
    border-bottom: 1px solid var(--c-secondary-neutral-3);
    font-size: 18px;
    margin-bottom: 40px;
    padding: 10px 0;
    line-height: 25px;

    &:empty {
      display: none;
    }
  }

  &__product-link {
    margin-top: 10px;
  }

  &__disclaimer {
    margin-top: 40px;

    &:empty {
      display: none;
    }
  }
}
</style>
